import { Container } from "@mui/material";
import { useReducer } from "react";
import Layout from "src/components/core/Layout";
import useDeviceSizes from "src/components/portfolio/hooks/useDeviceSizes";

interface IPaymentContainerProps {
  children: JSX.Element | JSX.Element[];
}

export const PaymentContainer = ({ children }: IPaymentContainerProps) => {
  const [useDefaultTheme, toggle] = useReducer((theme: any): boolean => !theme, true);
  const { isMobile } = useDeviceSizes();
  return (
    <Layout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
      <Container disableGutters={isMobile}>{children}</Container>
    </Layout>
  );
};
